import { type JSX, memo, useMemo } from 'react'

import { useGoogleMap } from '@react-google-maps/api'

export interface MarkerProps {
  title: string
  position: google.maps.LatLng | google.maps.LatLngLiteral
  options?: google.maps.marker.AdvancedMarkerElementOptions
}

const defaultOptions = {}

function MarkerFunctional({ position, options, title }: MarkerProps): JSX.Element | null {
  const map = useGoogleMap()

  useMemo(() => {
    if (!map) {
      return
    }
    new google.maps.marker.AdvancedMarkerElement({
      ...(options || defaultOptions),
      map: map,
      position: position,
      title: title,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <></>
}

export const Marker = memo(MarkerFunctional)
